import { normalize } from '@/utils/string'

export function matchCommandBarQuery(
  query: string,
  ...candidates: (string | undefined | null)[]
): boolean {
  const normalizedQuery = normalize(query)
  if (!normalizedQuery) return true

  return candidates.some((candidate) => {
    if (!candidate) return false
    return normalize(candidate).includes(normalizedQuery)
  })
}
